import { useContext } from "react";

import ChatSocketContext from "@/providers/ChatSocketContext";

const useChatSocket = () => {
  const chatContext = useContext(ChatSocketContext);
  return chatContext;
};
export default useChatSocket;
